import { Component } from '@angular/core';
import { AppService } from '../../../app.service';
import {NgxSmartModalService } from 'ngx-smart-modal';
import { Formvalidator } from '../../../EmployerComponent/EmployerFormComponent/employer.form.formvalidator';
import { ConfirmService } from '../../confirm/confirm.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import translateJson from "../../../../translate.json";
import customerJson from "../../../../assets/config/customer.json";
import { EmployerFormService } from 'app/EmployerComponent/EmployerFormComponent/employer.form.service';

enum StructureElementType { MINISTRY, ENTITY, SECTION };

@Component({
    selector: 'hierarchy-modal-comp',
    providers: [AppService, NgxSmartModalService],
    templateUrl: './hierarchy.modal.component.html',
    styleUrls: ['./hierarchy.modal.component.css']
})

export class HierarchyModalComponent {
    hierarchyModalData: string[] = [""];
    previousModalView: string;
    currentModalView: string;
    
    type: string;
    private i18 = translateJson.i18;
    private customerOrgId: String = customerJson.customer.organisationId;
    private customerName: String = customerJson.customer.name;
  
    private employer: any;
    private previousType: String;

    govMinistryForm: FormGroup;
    govEntityForm: FormGroup;
    govSectionForm: FormGroup;
    renameEntityForm: FormGroup;


    /* View Employer */
    showEmployerInformation: Boolean = true;
    showOtherInformation: Boolean = true;
    showDateDetailsInformation: Boolean = true;
    showRegisterDetailsInformation: Boolean = true;
    showContactDetailsInformation: Boolean = true;
    showNoteEditor: Boolean = false;
    showNotesDetails: Boolean = true;
    showLoader: Boolean = false;
    addHirarchyView: Boolean = true;
    confirmView: Boolean = false;
    removeView: Boolean = false;
    renameView: Boolean = false;
    errorView: Boolean = true;
    waitForConfirmationData: any;
    confirmationType: string;

    selectedView: any;
    selectedDepartmentOption: number;
    departmentArray: any = [];

    removeMessage: string;
    errorViewMessage: string;
    entityTypeToRemove: string;
    entityTypeToRename: string;
    confirmMessage: string;
    renameMessage: string;
    wantsToDelete: Boolean = false;
    assUpdateArray: any = [];
    softDeletedArray: any = [];


    departmentId: String;
    
    existingMinistryArray: any = [];
    ministryArray: any = [];
    entityArray: any = [];
    sectionArray: any = [];
    selectedMinistryId: String;
    selectedEntityId: String;

    StructureElementType = StructureElementType;

    constructor(private appService: AppService, 
                private ngxSmartModalService: NgxSmartModalService,
                private formValidator: Formvalidator,
                private confirmService: ConfirmService,
                private service: EmployerFormService
        ){
            this.setDefaults();
    }

    setDefaults(){
        this.govMinistryForm = new FormGroup({
            id: new FormControl(),
            newMinistry: new FormControl("", [Validators.required, Validators.minLength(2)]),
            selectedMinistry: new FormControl(null)
        });
        this.govEntityForm = new FormGroup({
            id: new FormControl(),
            newEntity: new FormControl({value: "", disabled: true}, [Validators.required, Validators.minLength(2)]),
            selectedEntity: new FormControl({value: null, disabled: true})
        });
        this.govSectionForm = new FormGroup({
            id: new FormControl(),
            newSection: new FormControl({value: "", disabled: true}, [Validators.required, Validators.minLength(2)]),
            selectedSection: new FormControl({value: null, disabled: true})
        }); 
        this.renameEntityForm = new FormGroup({
          newName: new FormControl("", [Validators.required, Validators.minLength(2)])
        });
    }
    /**
     * set error modal data
     */
    public setModalData(array: string[]){
        if(array.length === 1){
            this.hierarchyModalData = array;
        } else {
            this.hierarchyModalData = [this.i18.hierarchy.modal.setModalData1, "Okänt", "Ett fel har uppstått kontakta systemadministratören"];
        }
    }

    /**
     * Get the hierarcy modal
     */
    public getModalArray() {
        return this.hierarchyModalData;
    }

    /**
     * pop the hierarchy modal.
     */
    public pop(){
        this.ngxSmartModalService.setModalData(this.hierarchyModalData, 'hierarchyModal', true);
        this.ngxSmartModalService.getModal('hierarchyModal').open();

        this.type = this.hierarchyModalData[0];
        if(this.type === 'edit') {
            this.ministryArray = [];
            this.getDepartments()

        } else if (this.type === 'new') {
            this.ministryArray = [];
        }
        this.existingMinistryArray = []
        this.getExistingDepartments();
    }

    /**
     * Close the hierarchy modal and clear any data used
     */
    public close() {
      this.ministryArray = [];
      this.entityArray = [];
      this.sectionArray = [];
      this.assUpdateArray = [];
      this.govMinistryForm.reset();
      this.govEntityForm.reset();
      this.govSectionForm.reset();
      this.renameEntityForm.reset();
      this.ngxSmartModalService.getModal('hierarchyModal').close();
      this.errorView = false;
      this.addHirarchyView = true;
      // TODO: gör request för att hämta nya ändringar och uppdatera trädet.
    }

    //Get the existing departments for the hierarchy modal
    getExistingDepartments(){
      this.service.getAllDepartments().subscribe(
        data => this.setExixtsArray(data),
        error => this.showError(error.errro)
      )
    }

    setExixtsArray(data){
      this.existingMinistryArray = data;
    }

    getDepartments(){
        this.service.getAllDepartments().subscribe(
            data => this.patchDepartments(data),
            error => this.showError(error.error)
          )
    }

    enableInputs(from, value: boolean){
        if(from === 'ministry' && !value){
          this.entityArray = [];
          this.sectionArray = [];
          this.govEntityForm.get('newEntity').disable();
          this.govEntityForm.get('selectedEntity').disable();
          this.govEntityForm.get('selectedEntity').reset();
          this.govEntityForm.get('newEntity').reset();
          
          this.govSectionForm.get('newSection').disable();
          this.govSectionForm.get('selectedSection').disable();
          this.govSectionForm.get('selectedSection').reset();
          this.govSectionForm.get('newSection').reset();
        } else if (from === 'ministry' && value){
          this.govEntityForm.get('newEntity').enable();
          this.govEntityForm.get('selectedEntity').enable();
          this.govEntityForm.get('selectedEntity').setValue(null);
          this.enableInputs('entity', false);
        }
        
        if(from === 'entity' && !value){
          this.sectionArray = [];
          this.govSectionForm.get('newSection').disable();
          this.govSectionForm.get('selectedSection').disable();
          this.govSectionForm.get('selectedSection').reset();
          this.govSectionForm.get('newSection').reset();
        } else if (from === 'entity' && value){
          this.govSectionForm.get('newSection').enable();
          this.govSectionForm.get('selectedSection').enable();
          this.govSectionForm.get('selectedSection').setValue(null);
        }
      }

    /**
     * Refreshes the entity array with data
     * @param ministryId id of the selected ministry
     */
    patchEntityArr(ministryId){
        if(ministryId === null){
          this.selectedMinistryId = null;
        } else {
          this.selectedMinistryId = ministryId;
          if(this.type === 'new'){
            this.entityArray = this.ministryArray.find(ministry => ministry.ministryName === ministryId).govEntity
          } else {
            this.entityArray = this.ministryArray.find(ministry => ministry.ministryName === ministryId).govEntity
          }
        }
      }
      
      /**
       * Refreshes the Ministry array with new data
       * @param data updated data from backend
       */
      patchMinistryArr(){
        this.service.getAllDepartments().subscribe(
          data => {
            this.ministryArray = data
            this.patchEntityArr(this.selectedMinistryId)
            this.patchSectionArr(this.selectedEntityId)
          },
          error => this.showError(error)
        )
      }
      
      /**
       * Refreshes the section array with data
       * @param entityId id of the selected entity
       */
      patchSectionArr(entityId){
        if(entityId === null){
          this.selectedEntityId = null;
        } else {
          this.selectedEntityId = entityId;
          if(this.type === 'new'){
            this.sectionArray = this.entityArray.find(entity => entity.entityName === entityId).govSection
          } else {
            this.sectionArray = this.entityArray.find(entity => entity.entityName === entityId).govSection
          }
        }
      }
      
      /**
       * Adds a new ministry
       * @param newMinistryName name of the ministry to be added
       */
      addMinistry(newMinistryName){
        let alreadyExists: boolean = false;

        alreadyExists = this.checkForDublicates('ministry', newMinistryName)
        
        if(!alreadyExists){
          let newMinistry = {
            ministryName: newMinistryName,
            govEntity: []
          }
          if(this.type === 'new'){
            this.ministryArray.push(newMinistry);
            this.govMinistryForm.controls['selectedMinistry'].setValue(this.govMinistryForm.get('newMinistry').value);
            this.govMinistryForm.get('newMinistry').reset();
            this.selectedMinistryId = newMinistry.ministryName;
            this.patchEntityArr(this.govMinistryForm.get('selectedMinistry').value); 
            this.enableInputs('ministry', this.govMinistryForm.get('selectedMinistry').value != null)
          }
        } else {
          this.errorViewMessage = `${this.i18.goverment.form.govermentPart1Label} ${this.i18.hierarchy.modal.withName} "${newMinistryName}" ${this.i18.hierarchy.modal.alreadyExists}`
          this.changeView('errorView', 'addHirarchyView')
        }
      }
      
      /**
       * Adds a new entity
       * @param newEntityName name of the entity to be added
       */
      addEntity(newEntityName){
        let alreadyExists: boolean = false;
  
        if(this.entityArray.length > 0){
          alreadyExists = this.entityArray.find(entity => entity.entityName.toUpperCase() === newEntityName.toUpperCase()) ? true : false;
        }

        if(!alreadyExists){
          let newEntity = {
            entityName: newEntityName,
            govSection: []
          }
          let ministryPos;
          if(this.type === 'new'){
            ministryPos = this.ministryArray.findIndex(ministry => ministry.ministryName === this.govMinistryForm.value.selectedMinistry);
          } else {
            ministryPos = this.ministryArray.findIndex(ministry => ministry.ministryName === this.govMinistryForm.value.selectedMinistry);
          }
          
          this.ministryArray[ministryPos].govEntity.push(newEntity)
          this.govEntityForm.controls.newEntity.reset();    
        } else {
          this.errorViewMessage = `${this.i18.goverment.form.govermentPart2Label} ${this.i18.hierarchy.modal.withName} "${newEntityName}" ${this.i18.hierarchy.modal.alreadyExists}`
          this.changeView('errorView', 'addHirarchyView')
        }
      }
      
      /**
       * Adds a new section
       * @param newSectionName name of the section to be added
       */
      addSection(newSectionName){
        let alreadyExists:boolean = false;
  
        if(this.sectionArray.length > 0){
          alreadyExists = this.sectionArray.find(section => section.sectionName.toUpperCase() === newSectionName.toUpperCase()) ? true : false;
        }

        if(!alreadyExists){
          let newSection = {
            sectionName: newSectionName
          }

          let ministryPos = this.ministryArray.findIndex(ministry => ministry.ministryName === this.govMinistryForm.value.selectedMinistry);

          let entityPos = this.ministryArray[ministryPos].govEntity.findIndex(entity => entity.entityName === this.govEntityForm.value.selectedEntity);

          this.ministryArray[ministryPos].govEntity[entityPos].govSection.push(newSection);
          this.govSectionForm.controls.newSection.reset();
        } else {
          this.errorViewMessage = `${this.i18.goverment.form.govermentPart3Label} ${this.i18.hierarchy.modal.withName} "${newSectionName}" ${this.i18.hierarchy.modal.alreadyExists}`
          this.changeView('errorView', 'addHirarchyView')
        }
      }
      
      /**
       * Updates a the name of a ministry
       * @param newMinistryName new name of the ministry to be updated
       * @param ministryId id of the ministry to be updated
       */
      updateMinistry(newMinistryName, ministryId){
        let newAlreadyExists:boolean = false;
        let newChangedCase: boolean = false;
        let existingAlreadyExists: boolean = false;
        let existingChangedCase: boolean = false;
        let nameUnique: boolean = true;
  
        if(this.ministryArray.length > 0){
          this.ministryArray.forEach(ministry => {
            if(ministry.ministryName.toUpperCase() === newMinistryName.toUpperCase()){
              newAlreadyExists = true;
              newChangedCase = ministry.ministryName !== newMinistryName;
            }
          });
        }
        if(newAlreadyExists && newChangedCase){
          this.ministryArray.forEach(ministry => {
            if(ministry.ministryName !== this.govMinistryForm.get('selectedMinistry').value && newMinistryName.toUpperCase() === ministry.ministryName.toUpperCase()){
              nameUnique = false;
            }
          });
        }
        if(this.existingMinistryArray.length > 0){
          this.existingMinistryArray.forEach(ministry => {
            if(ministry.ministryName.toUpperCase() === newMinistryName.toUpperCase()){
              existingAlreadyExists = true;
              existingChangedCase = ministry.ministryName !== newMinistryName;
            }
          });
        }

        if(!newAlreadyExists && !existingAlreadyExists){
          let ministry;
          if(this.type === 'new'){
            ministry = this.ministryArray.find(m => m.ministryName === ministryId)
          } else {
            ministry = this.ministryArray.find(m => m.ministryName === ministryId)
          }
          let updateAssosiation = {
            oldName: ministry.ministryName,
            type: "ministry",
            newName: newMinistryName,
            departmentName: this.govMinistryForm.get('selectedMinistry').value,
            entityName: null
          }
          this.assUpdateArray.push(updateAssosiation)
          ministry.ministryName = newMinistryName;
          this.govMinistryForm.controls['selectedMinistry'].setValue(ministry.ministryName);
          this.renameEntityForm.reset();
          this.changeView('addHirarchyView', 'addHirarchyView')   
        } 
        else if (this.type === 'edit' && newAlreadyExists && newChangedCase && nameUnique) {
          let ministry;
          
          ministry = this.ministryArray.find(m => m.ministryName === ministryId)
          
          let updateAssosiation = {
            oldName: ministry.ministryName,
            type: "ministry",
            newName: newMinistryName,
            departmentName: this.govMinistryForm.get('selectedMinistry').value,
            entityName: null
          }
          this.assUpdateArray.push(updateAssosiation)
          ministry.ministryName = newMinistryName;
          this.govMinistryForm.controls['selectedMinistry'].setValue(ministry.ministryName);
          this.renameEntityForm.reset();
          this.changeView('addHirarchyView', 'addHirarchyView')
          
        } else if (this.type === 'new' && newAlreadyExists && newChangedCase && !existingAlreadyExists && !existingChangedCase) {
          let ministry;
          
          ministry = this.ministryArray.find(m => m.ministryName === ministryId)
          
          let updateAssosiation = {
            oldName: ministry.ministryName,
            type: "ministry",
            newName: newMinistryName,
            departmentName: this.govMinistryForm.get('selectedMinistry').value,
            entityName: null
          }
          this.assUpdateArray.push(updateAssosiation)
          ministry.ministryName = newMinistryName;
          this.govMinistryForm.controls['selectedMinistry'].setValue(ministry.ministryName);
          this.renameEntityForm.reset();
          this.changeView('addHirarchyView', 'addHirarchyView')
          
        } else {
          this.errorViewMessage = `${this.i18.goverment.form.govermentPart1Label} ${this.i18.hierarchy.modal.withName} "${newMinistryName}" ${this.i18.hierarchy.modal.alreadyExists}`
          this.changeView('errorView', 'renameView')
        }
      }
  
      /**
       * Asks user to confirm change then executes the request on confirmed.
       * @param newMinistryName name of the ministry to be updated
       * @param ministryId id of the ministry to be updated
       */
      confirmUpdateMinistry(newMinistryName, ministryId) {
        const ministry = this.ministryArray.find(m => m.id === ministryId);
        const confirmMsg = `${this.i18.hierarchy.modal.confirmUpdateMinistry1} ${this.i18.goverment.form.govermentPart1Label} ${this.i18.hierarchy.modal.withName} "${ministry.ministryName}" ${this.i18.hierarchy.modal.changeTo} ${newMinistryName}?`;
        this.confirmService.confirm(confirmMsg)
          .then(wantsToChange => {
            if (wantsToChange) {
              const oldName = ministry.ministryName;
              const type = 'ministry';
              ministry.ministryName = newMinistryName;
              
              this.service.updateGovName(ministry, ministryId, oldName, type, newMinistryName, null).subscribe(
                data => this.govMinistryForm.controls.newMinistry.reset(),
                error => this.showError(error)
              )
            }
          })
      }
      

      /**
       * Update the name of a entity
       * @param newEntityName new entity name
       * @param entityId id of entity
       */
      updateEntity(newEntityName, entityId){
        let alreadyExists:boolean = false;
        let changedCase: boolean = false;
        let nameUnique: boolean = true;
  
        //check if the name already exists
        if(this.entityArray.length > 0){
          this.entityArray.forEach(entity => {
            if(entity.entityName.toUpperCase() === newEntityName.toUpperCase()){
              alreadyExists = true;
              changedCase = entity.entityName !== newEntityName;
            }
          });
        }

        //check if the new name is unique for the hierarchy
        if(alreadyExists && changedCase){
          this.entityArray.forEach(entity => {
            if(entity.entityName !== this.govEntityForm.get('selectedEntity').value && newEntityName.toUpperCase() === entity.entityName.toUpperCase()){
              nameUnique = false;
            }
          });
        }

        if(!alreadyExists){
          let entity;
          if(this.type === 'new'){
            entity = this.entityArray.find(e => e.entityName === entityId)
          } else {
            entity = this.entityArray.find(e => e.entityName === entityId)
          }
          let updateAssosiation = {
            oldName: entity.entityName,
            type: "entity",
            newName: newEntityName,
            departmentName: this.govMinistryForm.get('selectedMinistry').value,
            entityName: this.govEntityForm.get('selectedEntity').value
          }
          this.assUpdateArray.push(updateAssosiation);

          entity.entityName = newEntityName;
          this.govEntityForm.controls['selectedEntity'].setValue(entity.entityName);
          this.renameEntityForm.reset();
          
          this.changeView('addHirarchyView', 'addHirarchyView')   
        } 
        else if (alreadyExists && changedCase && nameUnique) {
          let entity;
          entity = this.entityArray.find(e => e.entityName === entityId)

          let updateAssosiation = {
            oldName: entity.entityName,
            type: "entity",
            newName: newEntityName,
            departmentName: this.govMinistryForm.get('selectedMinistry').value,
            entityName: this.govEntityForm.get('selectedEntity').value
          }
          this.assUpdateArray.push(updateAssosiation);

          entity.entityName = newEntityName;
          this.govEntityForm.controls['selectedEntity'].setValue(entity.entityName);
          this.renameEntityForm.reset();
          
          this.changeView('addHirarchyView', 'addHirarchyView')
        }
        else {
          this.errorViewMessage = `${this.i18.goverment.form.govermentPart2Label} ${this.i18.hierarchy.modal.withName} "${newEntityName}" ${this.i18.hierarchy.modal.alreadyExists}`
          this.changeView('errorView', 'renameView')
        }
      }
  
      /**
       * Asks user to confirm change then executes the request on confirmed.
       * @param newEntityName new name of the entity to be updated
       * @param entityId id of the entity to be updated
       */
      confirmUpdateEntity(newEntityName, entityId) {
        const ministry = this.ministryArray.find(m => m.id === this.govMinistryForm.value.selectedMinistry)
        const entity = this.entityArray.find(e => e.id === entityId);
        const confirmMsg = `${this.i18.hierarchy.modal.confirmUpdateMinistry1} ${this.i18.goverment.form.govermentPart2Label} ${this.i18.hierarchy.modal.withName} "${entity.entityName}" ${this.i18.hierarchy.modal.changeTo} ${newEntityName}?`;
        this.confirmService.confirm(confirmMsg)
          .then(wantsToChange => {
            if (wantsToChange) {
              const oldName = entity.entityName;
              const type = 'entity';
              entity.entityName = newEntityName;
              
              this.service.updateGovName(ministry, ministry.id, oldName, type, newEntityName, null).subscribe(
                data => this.govEntityForm.controls.newEntity.reset(),
                error => this.showError(error)
              )
            }
          })
      }

      updateSection(newSectionName, sectionId){
        let alreadyExists:boolean = false;
        let changedCase: boolean = false;
        let nameUnique: boolean = true;
        if(this.sectionArray.length > 0){
          this.sectionArray.forEach(section => {
            if(section.sectionName.toUpperCase() === newSectionName.toUpperCase()){
              alreadyExists = true;
              changedCase = section.sectionName !== newSectionName;
            }
          });
        }


        if(alreadyExists && changedCase){
          this.sectionArray.forEach(section => {
            if(section.sectionName !== this.govSectionForm.get('selectedSection').value && newSectionName.toUpperCase() === section.sectionName.toUpperCase()){
              nameUnique = false;
            }
          });
        }
        
        const ministry = this.ministryArray.find(m => m.id === this.govMinistryForm.value.selectedMinistry);
        const entity = this.entityArray.find(e => e.id === this.govEntityForm.value.selectedEntity);
        if(!alreadyExists){
          let section;
          if(this.type === 'new'){
            section = this.sectionArray.find(s => s.sectionName === sectionId)
          } else {
            section = this.sectionArray.find(s => s.sectionName === sectionId)
          }
          let updateAssosiation = {
            oldName: section.sectionName,
            type: "section",
            newName: newSectionName,
            departmentName: this.govMinistryForm.get('selectedMinistry').value,
            entityName: this.govEntityForm.get('selectedEntity').value
          }
          this.assUpdateArray.push(updateAssosiation);

          section.sectionName = newSectionName;
          this.govSectionForm.controls['selectedSection'].setValue(section.sectionName);
          this.renameEntityForm.reset();
          
          this.changeView('addHirarchyView', 'addHirarchyView')
        } 
        else if (alreadyExists && changedCase && nameUnique) {
          let section;
          section = this.sectionArray.find(s => s.sectionName === sectionId)
          let updateAssosiation = {
            oldName: section.sectionName,
            type: "section",
            newName: newSectionName,
            departmentName: this.govMinistryForm.get('selectedMinistry').value,
            entityName: this.govEntityForm.get('selectedEntity').value
          }
          // kolla om redan finns i listan och filtrera bort innan tillägg likt för delete.
          this.assUpdateArray.push(updateAssosiation);

          section.sectionName = newSectionName;
          this.govSectionForm.controls['selectedSection'].setValue(section.sectionName);
          this.renameEntityForm.reset();
          
          this.changeView('addHirarchyView', 'addHirarchyView')
        }
        else {
          let errStr = `${this.i18.goverment.form.govermentPart3Label} ${this.i18.hierarchy.modal.withName} "${newSectionName}" ${this.i18.hierarchy.modal.alreadyExists}`
          this.errorViewMessage = `${this.i18.goverment.form.govermentPart3Label} ${this.i18.hierarchy.modal.withName} "${newSectionName}" ${this.i18.hierarchy.modal.alreadyExists}`;
          this.changeView('errorView', 'renameView')
        }
      }
  
      /**
       * Asks user to confirm change then executes the request on confirmed.
       * @param newSectionName new name of the section to be updated.
       * @param sectionId id of the section to be updated.
       * @param ministry The ministry to which the section belongs to.
       */
      confirmUpdateSection(newSectionName, sectionId, ministry) {
        const section = this.sectionArray.find(s => s.id === sectionId)
        const confirmMsg = `Vill du ändra namn på ${this.i18.goverment.form.govermentPart3Label} ${this.i18.hierarchy.modal.withName} "${section.sectionName}" ${this.i18.hierarchy.modal.changeTo} ${newSectionName}?`;
        this.confirmService.confirm(confirmMsg)
          .then(wantsToChange => {
            if (wantsToChange) {
              const oldName = section.sectionName;
              const type = 'section';
              section.sectionName = newSectionName;
              
              this.service.updateGovName(ministry, ministry.id, oldName, type, newSectionName, null).subscribe(
                data => this.govSectionForm.controls.newSection.reset(),
                error => this.showError(error)
              )
            }
          })
      }
      
      /**
       * populates the initial ministry array
       * @param data An array of ministries
       */
      patchDepartments(data) {
        if(this.ministryArray.length > 0){
          this.ministryArray = [];
        }
        if(data.length > 0) {
          this.ministryArray = data        
        } else {
          this.errorViewMessage = this.i18.hierarchy.modal.patchDepartments;
          this.changeView('errorView', 'errorView')
        }
      }
      
      /*
      * Helper to validate data before populating the array with it
      */
      validateInput(inputName, formArray) {
          let validInput = true;
          for(let i=0; i < formArray.length; i++) {
              if (inputName.toUpperCase() == formArray.value[i].ministryName.toUpperCase()) {
                  validInput = false;
              }
          }
          return validInput;
      }

      /**
     * Deletes the structure element based on ID and type.
     * @param id ID of the structure element.
     * @param type A StructureElementType.
     */
    deleteOrgStructureElement(id: string, type: StructureElementType) {
        if (type === StructureElementType.MINISTRY) {
          this.deleteGovMinistry(id);
        }
        else if (type === StructureElementType.ENTITY) {        
          this.deleteGovEntity(id);
        }
        else if (type === StructureElementType.SECTION) {
          this.deleteGovSection(id);
        }
        else {
          this.errorViewMessage = this.i18.hierarchy.modal.deleteOrgStructureElement
          this.changeView('errorView', 'errorView')
        }
      }
  
      /**
       * Deletes the GovMinistry and all its associated GovEntities and
       * GovSections, if the given ID exists.
       * @param id The ID of the GovMinistry.
       */
      async deleteGovMinistry(id: string) {
        let ministry;
        if(this.type === 'new'){
          ministry = this.ministryArray.find(m => m.ministryName === id)
        } else {
          ministry = this.ministryArray.find(m => m.ministryName === id)
        }
  
        if (ministry) {
          if(this.type === 'new'){
            this.ministryArray = this.ministryArray.filter(ministry => ministry.ministryName !== id)
            this.govMinistryForm.reset()
            this.enableInputs('ministry', false)
            this.changeView(this.previousModalView, this.previousModalView)
          } else {
            if(ministry.id != null || ministry.id != undefined){
              ministry.deleted = true;
              let softDelete = {
                id: ministry.id,
                type: 'ministry'
              }
              this.softDeletedArray.push(softDelete)
            } else {
              this.ministryArray = this.ministryArray.filter(ministry => ministry.ministryName !== id)
            }
            this.govMinistryForm.reset()
            this.enableInputs('ministry', false)
            this.changeView(this.previousModalView, this.previousModalView)
          }
        }
        else {
          this.errorViewMessage = `${this.i18.hierarchy.modal.somethingWrong} ${this.i18.goverment.form.govermentPart1Label} ${this.i18.hierarchy.modal.withName} "${id}" ${this.i18.hierarchy.modal.hasNotBeenRemoved}`
          this.changeView('errorView', 'addHirarchyView')
        }
      }
  
      /**
       * Deletes the GovEntity and all its associated GovSections,
       * if the given ID exists.
       * @param id The ID of the GovEntity.
       */
      async deleteGovEntity(id: string) {
        let entity;
        let ministryPos;
        if(this.type === 'new'){
          ministryPos = this.ministryArray.findIndex(m => m.ministryName === this.govMinistryForm.get('selectedMinistry').value)
          entity = this.ministryArray[ministryPos].govEntity.find(e => e.entityName === id);
        } else {
          ministryPos = this.ministryArray.findIndex(m => m.ministryName === this.govMinistryForm.get('selectedMinistry').value)
          entity = this.ministryArray[ministryPos].govEntity.find(e => e.entityName === id);
        }

        if (entity) {
          if(this.type === 'new'){
            this.ministryArray[ministryPos].govEntity = this.ministryArray[ministryPos].govEntity.filter(entity => entity.entityName !== id)
              this.entityArray = [];
              this.sectionArray = [];
              this.patchEntityArr(this.govMinistryForm.get('selectedMinistry').value);
              this.govEntityForm.controls['selectedEntity'].setValue(null);
              this.govSectionForm.disable();
              this.changeView(this.previousModalView, this.previousModalView)
          } else {
            if(entity.id != null || entity.id != undefined){
              entity.deleted = true;
              let softDelete = {
                id: entity.id,
                type: 'entity'
              }
              this.softDeletedArray.push(softDelete)
            } else {
              this.ministryArray[ministryPos].govEntity = this.ministryArray[ministryPos].govEntity.filter(entity => entity.entityName !== id)
            }
            this.entityArray = [];
            this.sectionArray = [];
            this.patchEntityArr(this.govMinistryForm.get('selectedMinistry').value);
            this.govEntityForm.controls['selectedEntity'].setValue(null);
            this.govSectionForm.disable();
            this.changeView(this.previousModalView, this.previousModalView)
          }
        } else {
          this.errorViewMessage = `${this.i18.hierarchy.modal.somethingWrong} ${this.i18.goverment.form.govermentPart2Label} ${this.i18.hierarchy.modal.withName} "${id}" ${this.i18.hierarchy.modal.hasNotBeenRemoved}`
          this.changeView('errorView', 'addHirarchyView')
        }      

      }
  
      /**
       * Deletes the GovSection if the given ID exists.
       * @param id The ID of the GovSection.
       */
      async deleteGovSection(id: string) {

        let section;
        let ministryPos;
        let entityPos;
        if(this.type === 'new'){
          ministryPos = this.ministryArray.findIndex(m => m.ministryName === this.govMinistryForm.get('selectedMinistry').value)
          entityPos = this.ministryArray[ministryPos].govEntity.findIndex(e => e.entityName === this.govEntityForm.get('selectedEntity').value);
          section = this.ministryArray[ministryPos].govEntity[entityPos].govSection.find(s => s.sectionName === id)
        } else {
          ministryPos = this.ministryArray.findIndex(m => m.ministryName === this.govMinistryForm.get('selectedMinistry').value)
          entityPos = this.ministryArray[ministryPos].govEntity.findIndex(e => e.entityName === this.govEntityForm.get('selectedEntity').value);
          section = this.ministryArray[ministryPos].govEntity[entityPos].govSection.find(s => s.sectionName === id)
        }
       
  
        if (section) {
          if(this.type === 'new'){
            this.ministryArray[ministryPos].govEntity[entityPos].govSection = this.ministryArray[ministryPos].govEntity[entityPos].govSection.filter(section => section.sectionName !== id)
          
            this.sectionArray = [];
            this.govSectionForm.controls['selectedSection'].setValue(null);
            this.changeView(this.previousModalView, this.previousModalView)
          } else {
            if(section.id != null || section.id != undefined){
              section.deleted = true;
              let softDelete = {
                id: section.id,
                type: 'section'
              }
              this.softDeletedArray.push(softDelete)
            } else {
              this.ministryArray[ministryPos].govEntity[entityPos].govSection = this.ministryArray[ministryPos].govEntity[entityPos].govSection.filter(section => section.sectionName !== id)
            }
            this.sectionArray = [];
            this.patchSectionArr(this.govEntityForm.get('selectedEntity').value);
            this.govSectionForm.controls['selectedSection'].setValue(null);
            this.changeView(this.previousModalView, this.previousModalView)
          }
          
        } else {
          this.errorViewMessage = `${this.i18.hierarchy.modal.somethingWrong} ${this.i18.goverment.form.govermentPart3Label} ${this.i18.hierarchy.modal.withName} "${id}" ${this.i18.hierarchy.modal.hasNotBeenRemoved}`
          this.changeView('errorView', 'addHirarchyView')
        }
    }

    /* Error modal on employer creation */
    showError(error) {
        this.confirmService.error(error);
    }
    
    /**
     * Save a new hierarchy to the database.
     */
    saveHierarchy(){
        this.service.saveHierarchy(this.ministryArray).subscribe(
            data => {},////TODO: change view to confirm that the data has been saved and an option for the user to close the modal console.log(data),
            error => this.showError(error)
          );
        //close the modal.
        this.close()
    }

    /**
     * Save a edited hierarchy to the database
     */
    updateHierarchy(){
        this.service.updateHierarchy(this.ministryArray, this.assUpdateArray, this.softDeletedArray).subscribe(
          data => {},//TODO: change view to confirm that the data has been saved and an option for the user to close the modal console.log(data),
          error => this.showError(error)
        );
        //close the modal.
        this.close()
        
    }

    /**
     * Removes or soft-delete's a hierarchy depending on if the hierarchy is already saved 
     * to the database or not. (added and then removed without beeing saved.)
     * @param fieldType type of the entity about ot be removed.
     * @param identifier name of the entity to be removed
     * @param prevView  the prevoius modal view
     */
    removeHierarchy(fieldType: string, identifier: string, prevView: string){
      this.changeView('removeView', prevView)
      this.entityTypeToRemove = fieldType;
      if(fieldType === 'ministry'){
        let ministry;
        if(this.type === 'new'){
          ministry = this.ministryArray.find(m => m.ministryName === identifier)
        } else {
          ministry = this.ministryArray.find(m => m.ministryName === identifier)
        }
       
  
        if (ministry) {
          if(this.type === 'new'){
            this.removeMessage = `${this.i18.hierarchy.modal.confirmRemove} ${this.i18.goverment.form.govermentPart1Label.toLowerCase()} ${this.i18.hierarchy.modal.withName} "${ministry.ministryName}"?
            ${this.i18.hierarchy.modal.noteThatAll} ${this.i18.goverment.form.govermentPart2Label}-${this.i18.hierarchy.modal.relationAnd} ${this.i18.goverment.form.govermentPart3Label}-${this.i18.hierarchy.modal.relationTo} "${ministry.ministryName}" ${this.i18.hierarchy.modal.willBeRemoved}`;
          } else {
            this.removeMessage = `${this.i18.hierarchy.modal.confirmRemove}  ${this.i18.goverment.form.govermentPart1Label.toLowerCase()} ${this.i18.hierarchy.modal.withName} "${ministry.ministryName}"?
            ${this.i18.hierarchy.modal.noteThatAll} ${this.i18.goverment.form.govermentPart2Label}-${this.i18.hierarchy.modal.relationAnd} ${this.i18.goverment.form.govermentPart3Label}-${this.i18.hierarchy.modal.relationTo} "${ministry.ministryName}" ${this.i18.hierarchy.modal.willBeRemoved}
            ${this.i18.hierarchy.modal.removeHierarchy}`;
          }
        }
      } else if(fieldType === 'entity'){
        let entity;
        if(this.type === 'new'){
          let ministryPos = this.ministryArray.findIndex(m => m.ministryName === this.govMinistryForm.get('selectedMinistry').value)
          entity = this.ministryArray[ministryPos].govEntity.find(e => e.entityName === identifier);
        } else {
          let ministryPos = this.ministryArray.findIndex(m => m.ministryName === this.govMinistryForm.get('selectedMinistry').value)
          entity = this.ministryArray[ministryPos].govEntity.find(e => e.entityName === identifier);
        }
       
  
        if (entity) {
          if(this.type === 'new'){
            this.removeMessage = `${this.i18.hierarchy.modal.confirmRemove} ${this.i18.goverment.form.govermentPart2Label.toLowerCase()} ${this.i18.hierarchy.modal.withName} "${entity.entityName}"?
            ${this.i18.hierarchy.modal.noteThatAll} ${this.i18.goverment.form.govermentPart3Label}-${this.i18.hierarchy.modal.relationTo} "${entity.entityName}" ${this.i18.hierarchy.modal.willBeRemoved}`;
          } else {
            this.removeMessage = `${this.i18.hierarchy.modal.confirmRemove} ${this.i18.goverment.form.govermentPart2Label.toLowerCase()} ${this.i18.hierarchy.modal.withName} "${entity.entityName}"?
            ${this.i18.hierarchy.modal.noteThatAll} ${this.i18.goverment.form.govermentPart3Label}-${this.i18.hierarchy.modal.relationTo} "${entity.entityName}" ${this.i18.hierarchy.modal.willBeRemoved}
            ${this.i18.hierarchy.modal.removeHierarchy}`
          }
        }
      } else if(fieldType === 'section'){
        let section;
        if(this.type === 'new'){
          let ministryPos = this.ministryArray.findIndex(m => m.ministryName === this.govMinistryForm.get('selectedMinistry').value)
          let entityPos = this.ministryArray[ministryPos].govEntity.findIndex(e => e.entityName === this.govEntityForm.get('selectedEntity').value);
          section = this.ministryArray[ministryPos].govEntity[entityPos].govSection.find(s => s.sectionName === identifier)
        } else {
          let ministryPos = this.ministryArray.findIndex(m => m.ministryName === this.govMinistryForm.get('selectedMinistry').value)
          let entityPos = this.ministryArray[ministryPos].govEntity.findIndex(e => e.entityName === this.govEntityForm.get('selectedEntity').value);
          section = this.ministryArray[ministryPos].govEntity[entityPos].govSection.find(s => s.sectionName === identifier)
        }
       
  
        if (section) {
          if(this.type === 'new'){
            this.removeMessage = `${this.i18.hierarchy.modal.confirmRemove} ${this.i18.goverment.form.govermentPart3Label.toLowerCase()} ${this.i18.hierarchy.modal.withName} "${section.sectionName}"?`;
          } else {
            this.removeMessage = `${this.i18.hierarchy.modal.confirmRemove} ${this.i18.goverment.form.govermentPart3Label.toLowerCase()} ${this.i18.hierarchy.modal.withName} "${section.sectionName}"?
            ${this.i18.hierarchy.modal.removeHierarchy}`;
          }
        }
      }

    }

    /**
     * Rename entity modal view messages
     * @param fieldType type of the entity about to be renamed
     * @param identifier name of the selected entity
     * @param prevView name of the previous view
     */
    renameField(fieldType: string, identifier: string, prevView: string){
      this.entityTypeToRename = fieldType;

      this.changeView('renameView', prevView)
      if(fieldType === 'ministry'){
        if(this.type === 'new'){
          this.renameMessage =`${this.i18.hierarchy.modal.changeNameFor} ${this.i18.goverment.form.govermentPart1Label.toLowerCase()} ${this.i18.hierarchy.modal.withName} "${this.govMinistryForm.get('selectedMinistry').value}"`;
        } else {
          this.renameMessage =`${this.i18.hierarchy.modal.changeNameFor} ${this.i18.goverment.form.govermentPart1Label.toLowerCase()} ${this.i18.hierarchy.modal.withName} "${this.govMinistryForm.get('selectedMinistry').value}"`
        }
      } else if(fieldType === 'entity'){
        if(this.type === 'new'){
          this.renameMessage =`${this.i18.hierarchy.modal.changeNameFor} ${this.i18.goverment.form.govermentPart2Label.toLowerCase()} ${this.i18.hierarchy.modal.withName} "${this.govEntityForm.get('selectedEntity').value}"`;
        } else {
          this.renameMessage =`${this.i18.hierarchy.modal.changeNameFor} ${this.i18.goverment.form.govermentPart2Label.toLowerCase()} ${this.i18.hierarchy.modal.withName} "${this.govEntityForm.get('selectedEntity').value}"`;
        }
      } else if(fieldType === 'section'){
        if(this.type === 'new'){
          this.renameMessage =`${this.i18.hierarchy.modal.changeNameFor} ${this.i18.goverment.form.govermentPart3Label.toLowerCase()} ${this.i18.hierarchy.modal.withName} "${this.govSectionForm.get('selectedSection').value}"`;
        } else {
          this.renameMessage =`${this.i18.hierarchy.modal.changeNameFor} ${this.i18.goverment.form.govermentPart3Label.toLowerCase()} ${this.i18.hierarchy.modal.withName} "${this.govSectionForm.get('selectedSection').value}"`;
        }
      }

    }

    /**
     * Checks if the Entity name already exists in the array
     * @param type Type of entity ex a govMinistry
     * @param identifier Name of the new entity
     */
    checkForDublicates(type:string, identifier:string){
      if(type === 'ministry'){
        let newEntryExists = this.ministryArray.find(ministry => ministry.ministryName.toUpperCase() === identifier.toUpperCase()) ? true : false;
        let alreadyExists;
        if(this.existingMinistryArray.length > 0){
          alreadyExists = this.existingMinistryArray.find(ministry => ministry.ministryName.toUpperCase() === identifier.toUpperCase()) ? true : false;
        }
        if(newEntryExists || alreadyExists) {
          return true;
        } 

      } else if(type === 'entity'){
        let newEntryExists = this.entityArray.find(entity => entity.entityName.toUpperCase() === identifier.toUpperCase()) ? true : false;
        let arrayPos = this.ministryArray.findIndex(ministry => ministry.ministryName === this.govMinistryForm.value.selectedMinistry);
        let alreadyExists = this.existingMinistryArray[arrayPos].govEntity.find(entity => entity.entityName.toUpperCase() === identifier.toUpperCase()) ? true : false;
        if(newEntryExists || alreadyExists) {
          return true;
        } 

      } else if(type === 'section'){
        let newEntryExists = this.sectionArray.find(section => section.sectionName.toUpperCase() === identifier.toUpperCase()) ? true : false;
        
        let ministryPos = this.ministryArray.findIndex(ministry => ministry.ministryName === this.govMinistryForm.value.selectedMinistry);
        let entityPos = this.ministryArray[ministryPos].govEntity.findIndex(entity => entity.entityName === this.govEntityForm.value.selectedEntity);
        let alreadyExists = this.existingMinistryArray[ministryPos].govEntity[entityPos].find(section => section.sectionName.toUpperCase() === identifier.toUpperCase()) ? true : false;
        if(newEntryExists || alreadyExists) {
          return true;
        } 

      }
      return false;
    }

    /**
     * Changes the modal view by setting booleans for what view to display
     * and defines what the current view is aswell as which the previous view was.
     * So that the user can go back one step.
     * @param view The new modal view to display
     * @param prevView The previous modal view to go back to if aborted.
     */
    changeView(view: string, prevView: string){
      if(view === 'removeView'){
        this.addHirarchyView = false;
        this.confirmView = false;
        this.removeView = true;
        this.renameView = false;
        this.errorView = false;
        this.currentModalView = view;
        this.previousModalView = prevView;
      } else if(view === 'renameView'){
        this.addHirarchyView = false;
        this.confirmView = false;
        this.removeView = false;
        this.renameView = true;
        this.errorView = false;
        this.currentModalView = view;
        this.previousModalView = prevView;
      } else if(view === 'confirmView'){
        this.addHirarchyView = false;
        this.confirmView = true;
        this.removeView = false;
        this.renameView = false;
        this.errorView = false;
        this.currentModalView = view;
        this.previousModalView = prevView;
      } else if(view === 'errorView'){
        this.addHirarchyView = false;
        this.confirmView = false;
        this.removeView = false;
        this.renameView = false;
        this.errorView = true;
        this.currentModalView = view;
        this.previousModalView = prevView;
      } else {
        //lägg till/redigera vyn.
        this.addHirarchyView = true;
        this.confirmView = false;
        this.removeView = false;
        this.renameView = false;
        this.errorView = false;
        this.currentModalView = view;
        this.previousModalView = prevView;

      }
    }

    /**
     * Modal confirm view to delete a hierarchy entity
     * @param fieldType Entity type about to be deleted
     * @param identifier id of the entity to be deleted
     */
    confirmDelete(fieldType: string, identifier: string){

      if(fieldType === 'entity'){
        this.deleteOrgStructureElement(identifier, StructureElementType.ENTITY)
      } else if(fieldType === 'section'){
        this.deleteOrgStructureElement(identifier, StructureElementType.SECTION)
      } else {
        this.deleteOrgStructureElement(identifier, StructureElementType.MINISTRY)
      }
    }

    /**
     * Clear modal confirmation view
     */
    modalAbort(){
      this.removeMessage = '';
      this.confirmMessage = '';
      this.renameMessage = '';
      this.confirmationType = '';
      this.waitForConfirmationData = null;
      this.changeView(this.previousModalView, this.previousModalView);
    }

    /**
     * Check if there is already a soft-deleted entity in the database
     * @param type entity type
     * @param nameToCheck Name that is being added
     * @param ministryId id of parent ministry if exists
     * @param entityId  id of parent entity if exists
     */
    checkForDeleted(type: string, nameToCheck, ministryId: string, entityId: string){
      let returnVal: boolean;
      if(type === 'ministry'){
        if(this.service.getGovMinistryByName(nameToCheck).subscribe(
          data => {this.confirmActivation('ministry', data)},
          notFound => {this.addMinistry(nameToCheck)}
        )){
        }

      } else if(type === 'entity'){
        this.service.getGovMinistryByIdAndEntityName(ministryId, nameToCheck).subscribe(
          data => {this.confirmActivation('entity', data)},
          notFound => {this.addEntity(nameToCheck)}
        )

      } else if(type === 'section'){
        this.service.getGovMinistryByIdAndEntityIdAndSectionName(ministryId, entityId, nameToCheck).subscribe(
          data => {this.confirmActivation('section', data)},
          notFound => {this.addSection(nameToCheck)}
        )

      } else if(type === 'update-ministry'){
        if(this.service.getGovMinistryByName(nameToCheck).subscribe(
          data => {this.confirmActivation('update-ministry', data)},
          notFound => {this.updateMinistry(nameToCheck, this.govMinistryForm.get('selectedMinistry').value)}
        )){
        }

      } else if(type === 'update-entity'){
        this.service.getGovMinistryByIdAndEntityName(ministryId, nameToCheck).subscribe(
          data => {this.confirmActivation('update-entity', data)},
          notFound => {this.updateEntity(nameToCheck, this.govEntityForm.get('selectedEntity').value)}
        )

      }else if(type === 'update-section'){
        this.service.getGovMinistryByIdAndEntityIdAndSectionName(ministryId, entityId, nameToCheck).subscribe(
          data => {this.confirmActivation('update-section', data)},
          notFound => {this.updateSection(nameToCheck, this.govSectionForm.get('selectedSection').value)}
        )

      } else {
      }
      return returnVal;
    }

    /**
     * Confirmation view when adding a new enity or changeing a existing name and the new name already exists
     * @param entityType type of the entity beeing added
     * @param data entity data ex a govMinistry object
     */
    confirmActivation(entityType:string, data:any){
      // TODO: bättre meddelande. kolla om arkiverad eller om namnet bara redan finns
      this.waitForConfirmationData = data;
      if(entityType === 'ministry'){
        this.confirmationType = 'ministry'
        this.confirmMessage = this.i18.hierarchy.modal.allReadyArchivedHieraki + " " + data.ministryName + ", " + this.i18.hierarchy.modal.wantToArchive
        this.changeView('confirmView', 'addHirarchyView')

      } else if(entityType === 'entity'){
        this.confirmationType = 'entity'
        this.confirmMessage = this.i18.hierarchy.modal.allReadyArchivedHieraki + " " + this.govEntityForm.get('newEntity').value + ", " + this.i18.hierarchy.modal.wantToArchive
        this.changeView('confirmView', 'addHirarchyView')

      } else if(entityType === 'section'){
        this.confirmationType = 'section'
        this.confirmMessage = this.i18.hierarchy.modal.allReadyArchivedHieraki + " " + this.govSectionForm.get('newSection').value + ", " + this.i18.hierarchy.modal.wantToArchive
        this.changeView('confirmView', 'addHirarchyView')

      } else if(entityType === 'update-ministry'){
        this.confirmationType = 'update-ministry'
        this.confirmMessage = this.i18.hierarchy.modal.allReadyArchivedHieraki + " " + this.renameEntityForm.get('newName').value+ ", " + this.i18.hierarchy.modal.wantToArchive
        this.changeView('confirmView', 'addHirarchyView')

      } else if(entityType === 'update-entity'){
        this.confirmationType = 'update-entity'
        this.confirmMessage = this.i18.hierarchy.modal.allReadyArchivedHieraki + " " + this.renameEntityForm.get('newName').value + ", " + this.i18.hierarchy.modal.wantToArchive
        this.changeView('confirmView', 'addHirarchyView')

      } else if(entityType === 'update-section'){
        this.confirmationType = 'update-section'
        this.confirmMessage = this.i18.hierarchy.modal.allReadyArchivedHieraki + " " + this.renameEntityForm.get('newName').value + ", " + this.i18.hierarchy.modal.wantToArchive
        this.changeView('confirmView', 'addHirarchyView')
      }
    }

    /**
     * do the selected operation (add/update/delete) and update the frontend array's
     */
    doConfirmation(){
      if(this.confirmationType === 'ministry'){
        this.ministryArray.push(this.waitForConfirmationData)
        this.govMinistryForm.controls['selectedMinistry'].setValue(this.govMinistryForm.get('newMinistry').value);
        this.govMinistryForm.get('newMinistry').reset();
        this.selectedMinistryId = this.waitForConfirmationData.ministryName;
        this.patchEntityArr(this.govMinistryForm.get('selectedMinistry').value); 
        this.enableInputs('ministry', this.govMinistryForm.get('selectedMinistry').value != null)
        this.changeView('addHirarchyView','addHirarchyView')
        this.waitForConfirmationData = null;
        this.confirmationType = ''

      } else if (this.confirmationType === 'entity'){
        let ministryPos = this.ministryArray.findIndex(ministry => ministry.ministryName === this.govMinistryForm.get('selectedMinistry').value);
        let entity = this.waitForConfirmationData.govEntity.find(entity => entity.entityName === this.govEntityForm.get('newEntity').value);
        entity.deleted = false;
        this.ministryArray[ministryPos].govEntity.push(entity)
        this.patchEntityArr(this.govMinistryForm.get('selectedMinistry').value); 
        this.govEntityForm.controls['selectedEntity'].setValue(entity.entityName);
        this.govEntityForm.controls.newEntity.reset();
        this.changeView('addHirarchyView','addHirarchyView')

      } else if(this.confirmationType === 'section'){
        let ministryPos = this.ministryArray.findIndex(ministry => ministry.ministryName === this.govMinistryForm.value.selectedMinistry);
        let entityPos = this.ministryArray[ministryPos].govEntity.findIndex(entity => entity.entityName === this.govEntityForm.value.selectedEntity);
        let entity = this.waitForConfirmationData.govEntity.find(entity => entity.entityName === this.govEntityForm.get('selectedEntity').value)
        let section = entity.govSection.find(section => section.sectionName === this.govSectionForm.get('newSection').value);
        section.deleted = false;
        this.ministryArray[ministryPos].govEntity[entityPos].govSection.push(section);
        this.patchSectionArr(this.govEntityForm.get('selectedEntity').value)
        this.govSectionForm.controls['selectedSection'].setValue(section.sectionName);
        this.govSectionForm.controls.newSection.reset();
        this.changeView('addHirarchyView','addHirarchyView')

      } else if(this.confirmationType === 'update-ministry'){
        this.ministryArray.push(this.waitForConfirmationData)
        this.govMinistryForm.controls['selectedMinistry'].setValue(this.waitForConfirmationData.ministryName);
        this.govMinistryForm.get('newMinistry').reset();
        this.selectedMinistryId = this.waitForConfirmationData.ministryName;
        this.patchEntityArr(this.govMinistryForm.get('selectedMinistry').value); 
        this.enableInputs('ministry', this.govMinistryForm.get('selectedMinistry').value != null)
        this.changeView('addHirarchyView','addHirarchyView')
        this.waitForConfirmationData = null;
        this.confirmationType = ''

      } else if (this.confirmationType === 'update-entity'){
        let ministryPos = this.ministryArray.findIndex(ministry => ministry.ministryName === this.govMinistryForm.get('selectedMinistry').value);
        let entity = this.waitForConfirmationData.govEntity.find(entity => entity.entityName === this.renameEntityForm.get('newName').value)
        entity.deleted = false;
        this.ministryArray[ministryPos].govEntity.push(entity)
        this.patchEntityArr(this.govMinistryForm.get('selectedMinistry').value);
        this.patchSectionArr(entity.entityName)
        this.govEntityForm.controls['selectedEntity'].setValue(entity.entityName);
        this.govEntityForm.controls.newEntity.reset();
        this.changeView('addHirarchyView','addHirarchyView')

      } else if(this.confirmationType === 'update-section'){
        let ministryPos = this.ministryArray.findIndex(ministry => ministry.ministryName === this.govMinistryForm.value.selectedMinistry);
        let entityPos = this.ministryArray[ministryPos].govEntity.findIndex(entity => entity.entityName === this.govEntityForm.value.selectedEntity);
        let entity = this.waitForConfirmationData.govEntity.find(entity => entity.entityName === this.govEntityForm.get('selectedEntity').value)
        let section = entity.govSection.find(section => section.sectionName === this.renameEntityForm.get('newName').value);
        section.deleted = false;
        this.ministryArray[ministryPos].govEntity[entityPos].govSection.push(section);
        this.patchSectionArr(this.govEntityForm.get('selectedEntity').value)
        this.govSectionForm.controls['selectedSection'].setValue(section.sectionName);
        this.govSectionForm.controls.newSection.reset();
        this.changeView('addHirarchyView','addHirarchyView')
      }
    }
}